import * as React from 'react';

import {FeatureGatePageWrapper} from './feature-gate-page-wrapper';

export function SmsCampaignsFeatureGate() {
    return (
        <FeatureGatePageWrapper
            header='Reach thousands of customers with automated SMS campaigns'
            subHeader='Create powerful SMS drip sequences to engage your audience over time'
            bullets={[
                'Send bulk text messages to thousands of customers simultaneously',
                'Build automated drip sequences that deliver messages on your schedule',
                'Keep customers engaged with perfectly timed follow-ups and reminders',
            ]}
            feature='smsCampaigns'
        />
    );
}
